import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";

const tabsList = [
  { id: 1, name: "Languages", route: "/tutorial-languages" },
  { id: 2, name: "Categories", route: "/tutorial-categories" },
  { id: 3, name: "Videos", route: "/videos-list" },
];

const TutorialVideos = () => {
  const navigate = useNavigate();

  const [tabs, setTabs] = useState(() => {
    const savedTabId = sessionStorage.getItem("tutorial_videos_active_tab");
    if (savedTabId) {
      const found = tabsList.find((tab) => tab.id === Number(savedTabId));
      if (found) return found;
    }
    return tabsList[0];
  });

  const handleTabClick = (tab) => {
    setTabs(tab);
    sessionStorage.setItem("tutorial_videos_active_tab", tab.id);
    navigate(tab.route);
  };

  return (
    <div>
      <Topbar header={"Tutorial Videos"} />
      <div className="d-flex flex-wrap gap-3">
        {tabsList.map((tab) => (
          <div
            key={tab.id}
            onClick={() => handleTabClick(tab)}
            className={`${tabs.id === tab.id ? "Act-tabs" : "tabs"} d-flex ac-jc pointer`}
          >
            {tab.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TutorialVideos;

